import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AccountService } from '../@tools/account';
import { Observable } from 'rxjs';


@Injectable()
export class AdminGuardService implements CanActivate {

    constructor(private router: Router, private account: AccountService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        return this.account.isAdmin.toPromise().then(res => {
            if (res) return true;
            return this.router.parseUrl('/auth');
        });
    }
}
